module.exports = {
  light: {
    background1: 'rgb(227,227,227)',
    background2: 'rgb(204,204,204)',
    background2hover: 'rgb(208,208,208)',
    foreground1: 'rgb(105,105,105)',
    text1: 'rgb(36,36,36)',
    text2: 'rgb(87,87,87)'
  },

  dark: {
    background1: 'rgb(35,35,35)',
    background2: 'rgb(54,54,54)',
    background2hover: 'rgb(58,58,58)',
    foreground1: 'rgb(112,112,112)',
    text1: 'rgb(235,235,235)',
    text2: 'rgb(161,161,161)'
  }
}



// WEBPACK FOOTER //
// ./src/themes.js